<template>
  <div class="alert bottom">
    <mu-card v-bind:class="[type]">
      <mu-card-text>
        <div class="alert-left" v-bind:class="{topAlign: align === 'top', middleAlign: align === 'middle'}">
          <mu-icon class="flex" :value="icon"></mu-icon>
        </div>
        <div class="alert-body" v-bind:class="{topAlign: align === 'top', middleAlign: align === 'middle'}">
          <slot name="content"></slot>
        </div>
        <div class="alert-after" v-bind:class="{topAlign: align === 'top', middleAlign: align === 'middle'}">
          <slot name="after"></slot>
        </div>
        <div>
          <slot name="action"></slot>
        </div>
      </mu-card-text>
    </mu-card>
  </div>
</template>
<script>
  export default {
    name: "alert",
    props: {
      type: {
        type: String,
        validator: function (value) {
          if (value === 'info') {
            return true;
          }
          if (value === 'warning') {
            return true;
          }
          if (value === 'success') {
            return true;
          }
          if (value === 'danger') {
            return true;
          }
          if (value === 'alert-color') {
            return true;
          }
        }
      },
      align: {
        type: String,
        default: 'middle',
        validator: function (value) {
          return value === 'top' || value === 'middle'
        }
      },
      icon: {
        type: String,
        required: false
      }
    }
  }
</script>

<style lang="less">
  @alert:  #E74C3C;
  @danger: #F2423E;
  @success: #7ECB46;
  @warning: #FDA430;
  @info: #0179d5;
  @textColor: white;
  .alert {
    .alert-body div {
      a.pointer {
        margin-top: 8px;
        display: inline-block;
        color: white !important;
        text-decoration: underline !important;
      }
    }
    .topAlign {
      vertical-align: top;
    }
    .middleAlign {
      vertical-align: middle;
    }
    .alert-left, .alert-body, .alert-after {
      display: table-cell;
      color: white;
    }
    .alert-left {
      align-items: center;
      .flex {
        display: flex;
        margin-right: 12px;
      }
    }
    .info {
      background: @info;
    }
    .warning {
      background: @warning;
    }
    .success {
      background: @success;
    }
    .danger {
      background: @danger;
    }
    .alert-color {
      background: @alert;
    }
  }
</style>



// WEBPACK FOOTER //
// Alert.vue?7efce62e